import { render, staticRenderFns } from "./MyOrdersList.vue?vue&type=template&id=d5aa33dc&scoped=true"
import script from "./MyOrdersList.vue?vue&type=script&lang=js"
export * from "./MyOrdersList.vue?vue&type=script&lang=js"
import style0 from "./MyOrdersList.vue?vue&type=style&index=0&id=d5aa33dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5aa33dc",
  null
  
)

export default component.exports